import React from "react"; 

import { Row, Col, Container } from 'reactstrap'; 
 
import CardSelect from 'components/Landpage/Card/Select'

import { 
    BannerImage,
    BannerOut,
    BannerContent
} from "./styled"; 


import { ButtonContent, ContentCenter, Subtitle, Title } from "ui/styled";
import Button from "components/Form/Button";
import { goContact } from "utils";


export default function BannerBottom(){ 
    
    return ( 
        <> 
            <BannerImage>
                <BannerOut />
                <BannerContent>
                    <Container>
                        <Row>
                            <Col md={{ size: 9 }}> 
                                <ContentCenter>
                                    <Subtitle>Soluções em Instalações Elétricas</Subtitle>
                                    <Title>Oferecemos soluções seguras e eficientes em instalações elétricas de pequeno, médio e grande porte</Title>

                                    <ButtonContent>
                                        <Button outline onClick={goContact}>Entrar em contato</Button>
                                    </ButtonContent>

                                </ContentCenter>
                            </Col>
                        </Row>
                    </Container>
                </BannerContent>
            </BannerImage>
        </>
    );
}